import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import consumer from "./cable";
import { selectSupplyAccount } from "../features/supplyAccounts/supplyAccountsSlice";

export const useSupplyAccountAlerts = (onReceived) => {
  const subscriptionsRef = useRef({});

  const account = useSelector(selectSupplyAccount);
  const connectionId = account.id

  useEffect(() => {
    if (!connectionId) return;

    Object.values(subscriptionsRef.current).forEach((sub) => sub.unsubscribe());
    subscriptionsRef.current = {};

    const subscription = consumer.subscriptions.create(
      {
        channel: "SupplyAccountNotesAlertConnectionChannel",
        connection_id: connectionId,
      },
      {
        received: (data) => {
          if (onReceived) onReceived(connectionId, data);
        },
      }
    );

    subscriptionsRef.current[connectionId] = subscription;

    return () => {
      subscription.unsubscribe();
      subscriptionsRef.current = {};
    };
  }, [connectionId, onReceived]);

  return connectionId;
};
